<template>
  <div class="panel-description" v-show="insideArr.length != 0">
    <div class="text-center" v-if="isInsErr">
      <insightErrMsg :compTitle="compTitle" :compId="compId"></insightErrMsg>
    </div>
    <div v-if="!isInsErr" class="carrousel">
      <ul class="slides" :style="paginIdx">
        <li class="slide" v-for="getins in insideArr" :key="getins">
          {{ getins }}
        </li>
      </ul>
      <div class="slidesNavigation">
        <label v-for="(getins , index) in insideArr" :key="getins" class="pagnination" v-on:click="pagNav(index)"
          :class="(paginNo == index) ? 'active' : ''" v-show="getins != null">
          <span></span>
        </label>
      </div>
      <button class="primary-nav-btn left-btn hide-on-presentation" :disabled="paginNo == 0" @click="pagNav(paginNo - 1)">
        <font-awesome-icon icon="fa-solid fa-angle-left" />
      </button>
      <button class="primary-nav-btn right-btn hide-on-presentation" :disabled="paginNo == insideArr.length - 1"
        @click="pagNav(paginNo + 1)">
        <font-awesome-icon icon="fa-solid fa-angle-right" />
      </button>
    </div>
  </div>
</template>
<script>
import insightErrMsg from './insErrMsg.vue';
export default {
  name: 'widgetsSlider',
  components: {
    insightErrMsg,
  },
  props: {
    insideArr: Array,
    isErr: Boolean,
    isInsErr: Boolean,
    compTitle: String,
    compId: String,
  },
  data() {
    return {
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
    }
  },
  methods: {
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
  }
}
</script>
<style scoped></style>
